import React, { Component } from 'react';
import { connect } from 'react-redux';
import Button from '../../../Button';
import BankSectionTitle from './BankInstructions/BankSectionTitle';
import { SmallError } from '../../../InputError';
import { fireBanksFetch, fireBranchesFetch, getBanks, getBranches, setUserBankData } from '../../../../reducers/banks';
import { getUserDetails, editUserDetails, didUserDetailsSuccess, didEditUserDetailsSuccess } from '../../../../reducers/userDetails';
import Select from 'react-select';

class BankDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      phoneNumber: this.props.summary.get('phoneNumber', this.props.userDetails.get('data').get('phoneNumber', '')),
      name: this.props.summary.get('firstName', this.props.userDetails.get('data').get('firstName', '')),
      lastName: this.props.summary.get('lastName', this.props.userDetails.get('data').get('lastName', '')),
      nationalIdNumber: this.props.summary.get('nationalIdNumber', this.props.userDetails.get('data').get('nationalIdNumber', '')),
      email: this.props.summary.get('email', this.props.userDetails.get('data').get('email', '')),
      bankName: '',
      branchNumber: '',
      bankNameSelect: '',
      branchNumberSelect: '',
      accountNumber: '',
      invalidBankName: null,
      invalidBranchNumber: null,
      invalidAccountNumber: null,
      empty: false
    };
    this.selectAllText = this.selectAllText.bind(this);
    this.continue = this.continue.bind(this);
    this.getValidationError = this.getValidationError.bind(this);
    this.captureInputs = this.captureInputs.bind(this);
    this.captureSelectInputs = this.captureSelectInputs.bind(this);
    this.captureSelectBranch = this.captureSelectBranch.bind(this);
  }

  componentDidUpdate() {
    const { bankName, branchNumber, accountNumber, empty, editUserDetailsSent } = this.state;
    if (bankName !== '' && branchNumber !== '' && accountNumber !== '' && empty === false) {
      this.setState({ empty: true });
    }
    // skip to next step if this instace sent the details update request and it succeeded
    if (this.props.didEditUserDetailsSuccess && editUserDetailsSent) {
      this.props.next();
    }
  }

  componentDidMount() {
    this.props.fireBanksFetch();
  }

  continue(event) {
    event.preventDefault();
    const i18n = this.props.lang.i18n;
    const phoneValidation = /^((\d|-|\+)+)$/;
    const textValidation = /^(([^\u0000-\u007f]+|\w|-|\s)+)$/;
    const emptyValidation = /^$/;
    const invalidBankName = this.getValidationError(
      this.state.bankName,
      textValidation,
      emptyValidation,
      i18n('onboarding.bankDetails.bankNameError'),
      i18n('onboarding.bankDetails.bankNameError')
    );
    const invalidBranchNumber = this.getValidationError(
      this.state.branchNumber,
      textValidation,
      emptyValidation,
      i18n('onboarding.bankDetails.branchNumberError'),
      i18n('onboarding.bankDetails.branchNumberError')
    );
    const invalidAccountNumber = this.getValidationError(
      this.state.accountNumber,
      phoneValidation,
      emptyValidation,
      i18n('onboarding.bankDetails.accountNumberError'),
      i18n('onboarding.bankDetails.accountNumberError')
    );
    this.setState({
      invalidBankName,
      invalidBranchNumber,
      invalidAccountNumber
    });

    let userData = this.props.userDetails.get('data');
    userData = userData.set('firstName', this.state.name);
    userData = userData.set('lastName', this.state.lastName);
    userData = userData.set('email', this.state.email);
    userData = userData.set('phoneNumber', this.state.phoneNumber);
    userData = userData.set('nationalIdNumber', this.state.nationalIdNumber);
    userData = userData.set('bankBranch', this.state.branchNumber);
    userData = userData.set('bankAccountNumber', this.state.accountNumber);

    if (textValidation.test(this.state.bankName) && textValidation.test(this.state.branchNumber) && phoneValidation.test(this.state.accountNumber)) {
      this.props.setUserBankData({ branch: this.state.branchNumber, accountNumber: this.state.accountNumber, bankName: this.state.bankName });
      this.props.editUserDetails(userData);
      this.setState({ editUserDetailsSent: true });
    } else {
      this.setState({ empty: false });
    }
  }

  getValidationError(value, regexFormat, regexEmpty, errorFormat, errorEmpty) {
    if (regexEmpty.test(value)) {
      return <SmallError message={errorEmpty} />;
    } else if (!regexFormat.test(value)) {
      return <SmallError message={errorFormat} />;
    } else {
      return null;
    }
  }

  captureInputs(event) {
    const target = event.target;
    const val = event.target.value;

    const name = event.target.name;
    this.setState({
      [name]: val,
      privacyPolicy: target.checked,
      invalidBankName: null,
      invalidBranchNumber: null,
      invalidAccountNumber: null
    });
  }

  captureSelectInputs(bankName) {
    this.setState({
      bankName: bankName.value,
      bankNameSelect: bankName
    });
    if (bankName) {
      this.props.fireBranchesFetch(bankName.value);
    }
  }

  captureSelectBranch(branchNumber) {
    this.setState({
      branchNumber: branchNumber.value,
      branchNumberSelect: branchNumber
    });
  }

  selectAllText(event) {
    event.target.select();
  }
  render() {
    const i18n = this.props.lang.i18n;
    const errorBank = this.state.invalidBankName;
    const errorBranchNumber = this.state.invalidBranchNumber;
    const errorAccontNumber = this.state.invalidAccountNumber;
    const banks = this.props.banks ? this.props.banks : [];
    const emptyInputClass = !this.state.bankName ? 'bankDetails__select__placeholder' : '';
    const colourStyles = {
      option: styles => ({ ...styles, width: '100%' }),
      singleValue: styles => ({ ...styles, width: '100%' }),
      placeholder: styles => ({ ...styles, width: '100%' })
    };
    const banksFetch = banks.map((bank, i) => {
      return { value: `${bank.get('code')}`, label: `${bank.get('name')} (${bank.get('code')})` };
    });
    const branches = this.props.branch ? this.props.branch : [];
    const branchesFetch = branches.map((branches, i) => {
      return { value: `${branches.get('id')}`, label: `${branches.get('name')} (${branches.get('code')})` };
    });
    const { bankNameSelect, branchNumberSelect } = this.state;
    return (
      <div className="bankDetails text-center">
        <BankSectionTitle i18n={i18n} />
        <div className="row justify-content-center">
          <div className="col-9 col-sm-5">
            <form className="form">
              <div className="bankDetails__selectWrapper">
                <Select
                  className={`bankDetails__select w-100 ${emptyInputClass} ${
                    this.state.invalidBankName !== null ? 'form__input--error mw-100' : 'mw-100'
                  }`}
                  styles={colourStyles}
                  classNamePrefix="select"
                  placeholder={i18n('onboarding.bankDetails.bankName')}
                  value={bankNameSelect}
                  onChange={this.captureSelectInputs}
                  options={banksFetch}
                />
                {errorBank}
              </div>
              <Select
                className={`s${this.state.invalidBranchNumber !== null ? 'form__input--error mw-100' : 'form__input mw-100 mb-4'}`}
                classNamePrefix="select"
                styles={colourStyles}
                placeholder={i18n('onboarding.bankDetails.branchNumber')}
                value={branchNumberSelect}
                onChange={this.captureSelectBranch}
                options={branchesFetch}
              />
              {errorBranchNumber}
              <input
                className={`form__input ${this.state.invalidAccountNumber !== null ? 'form__input--error mw-100' : 'form__input mw-100'}`}
                name="accountNumber"
                onChange={this.captureInputs}
                onClick={this.selectAllText}
                placeholder={i18n('onboarding.bankDetails.accountNumber')}
              />
              {errorAccontNumber}
              <Button
                className={'next_button'}
                text={i18n('onboarding.bankDetails.buttonText')}
                disabled={!this.state.empty}
                onClick={this.continue}
              />
            </form>

            <div className="section" />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  lang: state.lang,
  userDetails: getUserDetails(state),
  // banks: state.sendBanks,
  banks: getBanks(state),
  // branch: state.sendBranch,
  branch: getBranches(state),
  statusEditUser: state.statusEditUser,
  didUserDetailsSuccess: didUserDetailsSuccess(state),
  didEditUserDetailsSuccess: didEditUserDetailsSuccess(state)
});

const mapDispatchToProps = dispatch => ({
  fireBanksFetch: () => dispatch(fireBanksFetch()),
  fireBranchesFetch: bankCode => dispatch(fireBranchesFetch(bankCode)),
  editUserDetails: data => dispatch(editUserDetails(data)),
  setUserBankData: data => dispatch(setUserBankData(data))
});

export default connect(mapStateToProps, mapDispatchToProps)(BankDetails);



// WEBPACK FOOTER //
// ./src/components/Views/Onboarding/Steps/BankDetails.js